module.exports = __webpack_public_path__ + "static/media/whiteLogo.bdd7f818.png";